import { siteData } from '@/data/siteData';

export function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(5, 10, 20, 0.7), rgba(5, 10, 20, 0.7)), url('/images/hero.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="absolute inset-0 bg-brand-navy/40" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 mb-6 animate-pulse">
          <div className="w-2 h-2 rounded-full bg-brand-gold" />
          <span className="text-brand-gold text-xs font-bold uppercase tracking-widest">
            24/7 Compassionate Care
          </span>
        </div>
        <h1 className="serif text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          {siteData.name}<br />
          <span className="italic text-brand-gold">{siteData.nameAfrikaans}</span>
        </h1>
        <p className="text-lg md:text-xl text-brand-light/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteData.tagline}<br />
          <span className="block mt-2 text-brand-gold/90 italic">{siteData.taglineAfrikaans}</span>
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#contact" className="btn-primary">
            Contact Us
          </a>
          <a
            href={`https://wa.me/${siteData.whatsappPhone.replace('+', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline"
          >
            WhatsApp Chat
          </a>
        </div>
      </div>
    </section>
  );
}